import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
// Create context
const AnalyticsContext = createContext(null);
// Analytics Provider component
export const AnalyticsProvider = ({ children, posthog }) => {
    return (_jsx(AnalyticsContext.Provider, { value: { posthog }, children: children }));
};
// Hook to access PostHog
export const usePostHogInstance = () => {
    const context = useContext(AnalyticsContext);
    if (!context) {
        // Fallback for when no provider is available
        return null;
    }
    return context.posthog;
};
